import { Key, useState } from 'react';
import { Tab, Tabs } from '@heroui/react';
import { ErrorWidget } from '@/widgets/ErrorWidget';
import { EnrollmentTermStatus, useGetEnrollmentTermItemsQuery } from '@/entities/Enrollment';
import { SectionLoader } from '@/shared/ui/Loader';
import { Section } from '@/shared/ui/Section';
import { EnrollmentsList } from '../../components/EnrollmentsList';

export const EnrollmentsView = () => {
  const [status, setStatus] = useState<EnrollmentTermStatus>('active');

  const { data, isLoading, isFetching, error } = useGetEnrollmentTermItemsQuery(status);

  const isInitialLoading = isLoading && !data;

  const handleChangeStatus = (key: Key) => setStatus(key as EnrollmentTermStatus);

  if (isInitialLoading) {
    return <SectionLoader />;
  }

  if (error) {
    return <ErrorWidget error="Failed to load enrollment terms" />;
  }

  return (
    <Section typeSection="section" className="flex flex-col gap-y-6">
      <Tabs
        variant="underlined"
        selectedKey={status}
        onSelectionChange={handleChangeStatus}
        aria-label="Enrollment terms filter"
      >
        <Tab key="active" title="Active">
          {isFetching && status === 'active' ? (
            <SectionLoader />
          ) : (
            <EnrollmentsList list={data || []} emptyMessage="There are no active courses." />
          )}
        </Tab>
        <Tab key="completed" title="Completed">
          {isFetching && status === 'completed' ? (
            <SectionLoader />
          ) : (
            <EnrollmentsList list={data || []} emptyMessage="There are no completed courses." />
          )}
        </Tab>
      </Tabs>
    </Section>
  );
};
